import { render } from "./SettingsPostResults.vue?vue&type=template&id=c7ebe89c"
import script from "./SettingsPostResults.vue?vue&type=script&lang=js"
export * from "./SettingsPostResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__